import { toGQLLocale } from '../gql/utils/gql-locale';
import { useLocalization } from '../providers/LocaleProvider';

export const useGQLLocale = () => {
  const { locale } = useLocalization();

  return toGQLLocale(locale);
};
